module.exports = __webpack_public_path__ + "img/dtrf_logo.649ffab4.png";